// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
@keyframes antCheckboxEffect {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}
.nkl-checkbox {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: 0.2em;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
}
.nkl-checkbox-wrapper:hover .nkl-checkbox-inner,
.nkl-checkbox:hover .nkl-checkbox-inner,
.nkl-checkbox-input:focus + .nkl-checkbox-inner {
  border-color: #1890ff;
}
.nkl-checkbox-checked::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #1890ff;
  border-radius: 2px;
  visibility: hidden;
  animation: antCheckboxEffect 0.36s ease-in-out;
  animation-fill-mode: backwards;
  content: '';
}
.nkl-checkbox:hover::after,
.nkl-checkbox-wrapper:hover .nkl-checkbox::after {
  visibility: visible;
}
.nkl-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  direction: ltr;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
}
.nkl-checkbox-inner::after {
  position: absolute;
  top: 50%;
  left: 21.5%;
  display: table;
  width: 5.71428571px;
  height: 9.14285714px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(0) translate(-50%, -50%);
  opacity: 0;
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  content: ' ';
}
.nkl-checkbox-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
.nkl-checkbox-checked .nkl-checkbox-inner::after {
  position: absolute;
  display: table;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1) translate(-50%, -50%);
  opacity: 1;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  content: ' ';
}
.nkl-checkbox-checked .nkl-checkbox-inner {
  background-color: #1890ff;
  border-color: #1890ff;
}
.nkl-checkbox-disabled {
  cursor: not-allowed;
}
.nkl-checkbox-disabled.nkl-checkbox-checked .nkl-checkbox-inner::after {
  border-color: rgba(0, 0, 0, 0.25);
  animation-name: none;
}
.nkl-checkbox-disabled .nkl-checkbox-input {
  cursor: not-allowed;
  pointer-events: none;
}
.nkl-checkbox-disabled .nkl-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
}
.nkl-checkbox-disabled .nkl-checkbox-inner::after {
  border-color: #f5f5f5;
  border-collapse: separate;
  animation-name: none;
}
.nkl-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.nkl-checkbox-disabled:hover::after,
.nkl-checkbox-wrapper:hover .nkl-checkbox-disabled::after {
  visibility: hidden;
}
.nkl-checkbox-wrapper {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-flex;
  align-items: baseline;
  line-height: unset;
  cursor: pointer;
}
.nkl-checkbox-wrapper::after {
  display: inline-block;
  width: 0;
  overflow: hidden;
  content: '\\a0';
}
.nkl-checkbox-wrapper.nkl-checkbox-wrapper-disabled {
  cursor: not-allowed;
}
.nkl-checkbox-wrapper + .nkl-checkbox-wrapper {
  margin-left: 8px;
}
.nkl-checkbox-wrapper.nkl-checkbox-wrapper-in-form-item input[type='checkbox'] {
  width: 14px;
  height: 14px;
}
.nkl-checkbox + span {
  padding-right: 8px;
  padding-left: 8px;
}
.nkl-checkbox-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.nkl-checkbox-group-item {
  margin-right: 8px;
}
.nkl-checkbox-group-item:last-child {
  margin-right: 0;
}
.nkl-checkbox-group-item + .nkl-checkbox-group-item {
  margin-left: 0;
}
.nkl-checkbox-indeterminate .nkl-checkbox-inner {
  background-color: #fff;
  border-color: #d9d9d9;
}
.nkl-checkbox-indeterminate .nkl-checkbox-inner::after {
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #1890ff;
  border: 0;
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  content: ' ';
}
.nkl-checkbox-indeterminate.nkl-checkbox-disabled .nkl-checkbox-inner::after {
  background-color: rgba(0, 0, 0, 0.25);
  border-color: rgba(0, 0, 0, 0.25);
}
.nkl-checkbox-rtl {
  direction: rtl;
}
.nkl-checkbox-group-rtl .nkl-checkbox-group-item {
  margin-right: 0;
  margin-left: 8px;
}
.nkl-checkbox-group-rtl .nkl-checkbox-group-item:last-child {
  margin-left: 0 !important;
}
.nkl-checkbox-group-rtl .nkl-checkbox-group-item + .nkl-checkbox-group-item {
  margin-left: 8px;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
